//
//
//

export default {
  mounted () {
    setTimeout(() => {
      const yotpoWrapper = window.document.getElementsByClassName('yotpo-display-wrapper').length > 0
        ? window.document.getElementsByClassName('yotpo-display-wrapper')[0]
        : null
      if (yotpoWrapper) {
        const title = document.createElement('div')
        title.textContent = 'Reviews'
        title.className = 'h2'
        yotpoWrapper.insertBefore(title, yotpoWrapper.firstChild)
        document.getElementsByClassName('yotpo-label')[0].remove()
        document.getElementsByClassName('yotpo-nav-primary')[0].remove()
        Array.from(document.getElementsByClassName('yotpo-icon-profile')).forEach((item) => {
          item.remove()
        })
        Array.from(document.getElementsByClassName('product-link-wrapper')).forEach((item) => {
          item.remove()
        })
        Array.from(document.getElementsByClassName('yotpo-user-title')).forEach((item) => {
          item.textContent = 'Verified buyer'
        })
        Array.from(document.getElementsByClassName('label-helpful')).forEach((item) => {
          item.remove()
        })
      }
    }, 1000)
  }
}
